export const permissions = (state) => state.permissions
export const permissionsByTeam = (state) => state.permissionsByTeam
export const activeTeamId = (state) => state.activeTeamId
export const allPermissions = (state) => state.all

